import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config';
import { ProductionTypes } from '../app-config-production-types';

@Injectable({
  providedIn: 'root',
})
export class ProductionTypesService {
  constructor(private appConfig: AppConfig) {}

  isProductionTypeIndustrialCam(): boolean {
    return this.appConfig.productionType === ProductionTypes.isIndustrialCam;
  }

  isProductionTypeMiningOrIndustrialCam(): boolean {
    return this.appConfig.productionType === ProductionTypes.isMining || this.appConfig.productionType === ProductionTypes.isIndustrialCam;
  }
}
